import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";
import { z } from "zod";

export const extensionSchema = z.object({
  end_date: requiredString(),
  category: requiredString().min(1, REQUIRED_MESSAGE),
  reason: requiredString().min(1, REQUIRED_MESSAGE),
  justification: requiredString().min(2, REQUIRED_MESSAGE),
});
